import { render, staticRenderFns } from "./PddBaseStepTwo.vue?vue&type=template&id=062ac05e&scoped=true&"
import script from "./PddBaseStepTwo.vue?vue&type=script&lang=js&"
export * from "./PddBaseStepTwo.vue?vue&type=script&lang=js&"
import style0 from "./PddBaseStepTwo.vue?vue&type=style&index=0&id=062ac05e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062ac05e",
  null
  
)

export default component.exports